var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup509(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_509",
    "data-name": "Group 509",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.076,
    height: 46.706,
    viewBox: "0 0 48.076 46.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3497",
    "data-name": "Path 3497",
    d: "M-389.03,189.325a14.8,14.8,0,0,1,8.226,3.252,12.687,12.687,0,0,1,4.448,5.076,10.86,10.86,0,0,1,.71,5.3,11.38,11.38,0,0,0,3.767,9.6q7.575,7.22,15.1,14.5a5.1,5.1,0,0,1,1.673,2.661,4.153,4.153,0,0,1-2.263,4.6,4.056,4.056,0,0,1-5-1.121c-2.182-2.85-4.343-5.718-6.439-8.632-2.119-2.947-4.169-5.944-6.212-8.945a11.565,11.565,0,0,0-9.523-5.348,9.355,9.355,0,0,1-7.285-3.792,18.032,18.032,0,0,1-3.753-8.64,9.257,9.257,0,0,1,.563-5.191C-393.909,190.217-391.877,189.331-389.03,189.325Z",
    transform: "translate(395.713 -188.028)",
    fill: "#febaba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M-187.731,202.3a8.8,8.8,0,0,0-3.7.6.57.57,0,0,1-.483-.028q-1.7-1.6-3.357-3.247a1.243,1.243,0,0,1-.265-1.229,11.68,11.68,0,0,0,.247-2.918,9.312,9.312,0,0,1,3-7.921c2.833-2.679,5.613-5.414,8.414-8.127a1.574,1.574,0,0,1,1.406-.6,1.293,1.293,0,0,1,1.073.9,1.406,1.406,0,0,1-.37,1.47c-1.316,1.383-2.622,2.774-3.934,4.161q-1.565,1.655-3.135,3.306a1.711,1.711,0,0,0-.491,1.8,1.646,1.646,0,0,0,2.828.566c1.129-1.163,2.223-2.361,3.331-3.544,1.207-1.288,2.4-2.585,3.624-3.86a1.615,1.615,0,0,1,1.969-.363,1.538,1.538,0,0,1,.846,1.744,3.034,3.034,0,0,1-.712,1.184c-2.184,2.369-4.4,4.7-6.59,7.072a1.659,1.659,0,0,0,.777,2.845,1.8,1.8,0,0,0,1.785-.717q3.414-3.677,6.84-7.344a1.424,1.424,0,0,1,1.45-.595,1.332,1.332,0,0,1,.642,2.236c-1.091,1.308-2.2,2.6-3.3,3.9-1.486,1.753-3,3.484-4.456,5.26A8.89,8.89,0,0,1-187.731,202.3Z",
    transform: "translate(220.241 -178.801)",
    fill: "#febaba"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    d: "M-352.713,409.7l3.158,4.67c-.7.9-1.409,1.824-2.127,2.737-2.4,3.047-4.781,6.1-7.2,9.133a4.113,4.113,0,0,1-6.043.552,4.072,4.072,0,0,1,0-6.144c3.97-3.624,7.982-7.2,11.978-10.8A2.194,2.194,0,0,1-352.713,409.7Z",
    transform: "translate(369.947 -381.253)",
    fill: "#febaba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup509);
export default __webpack_public_path__ + "static/media/Group 509.1d68da976ef0d2c3e79d6ee1db7859b5.svg";
export { ForwardRef as ReactComponent };